export const BI_CHANGE_ORDERING = 'bi/CHANGE_ORDERING';
export const BI_INITIATE_LOAD_MORE = 'bi/INITIATE_LOAD_MORE';
export const BI_OPEN_COMMENT_ACTIONS = 'bi/OPEN_COMMENT_ACTIONS';
export const BI_SELECT_COMMENT_ACTION = 'bi/SELECT_COMMENT_ACTION';
export const BI_DISCARD_COMMENT = 'bi/DISCARD_COMMENT';
export const BI_VISIT_MEMBER_PROFILE = 'bi/VISIT_MEMBER_PROFILE';
export const BI_SHOW_ZERO_COMMENTS_EMPTY_STATE = 'bi/SHOW_ZERO_COMMENTS_EMPTY_STATE';
export const BI_SHOW_FALLBACK_STATE = 'bi/BI_SHOW_FALLBACK_STATE';
export const BI_ATTEMPT_LOGIN_SIGNUP = 'bi/ATTEMPT_LOGIN_SIGNUP';
export const BI_INITIATE_FILE_UPLOAD = 'bi/INITIATE_FILE_UPLOAD';
export const BI_INITIATE_IMAGE_UPLOAD = 'bi/IMAGE_UPLOAD_START';
export const BI_INITIATE_REACTION = 'bi/BI_INITIATE_REACTION';
export const BI_CLICK_SHOW_MORE_BTN = 'bi/CLICK_SHOW_MORE_BTN';
export const BI_CLICK_PUBLISH_SELECT_BTN = 'bi/CLICK_PUBLISH_SELECT_BTN';
export const BI_COMMENT_FORM_EXPANDED = 'bi/COMMENT_FORM_EXPANDED';
export const BI_CAPTCHA_EVENT = 'bi/CLICK_CAPTCHA_EVENT';
export const BI_OPEN_REACTION_LIST = 'bi/OPEN_REACTION_LIST';
export const BI_CLICK_EMOTION_LIST_TAB = 'bi/CLICK_EMOTION_LIST_TAB';
export const BI_SHOW_COMMENT_REPLY_SUBMISSION_WARNING = 'bi/SHOW_COMMENT_REPLY_SUBMISSION_WARNING';
export const biChangeOrdering = (payload) => ({
    type: BI_CHANGE_ORDERING,
    payload,
});
export const biOpenCommentActions = (payload) => ({
    type: BI_OPEN_COMMENT_ACTIONS,
    payload,
});
export const biSelectCommentAction = (payload) => ({ type: BI_SELECT_COMMENT_ACTION, payload });
export const biDiscardComment = (payload) => ({
    type: BI_DISCARD_COMMENT,
    payload,
});
export const biVisitMemberProfile = (payload) => ({
    type: BI_VISIT_MEMBER_PROFILE,
    payload,
});
export const biShowZeroCommentsEmptyState = (payload) => ({
    type: BI_SHOW_ZERO_COMMENTS_EMPTY_STATE,
    payload,
});
export const biShowFallbackState = (payload) => ({
    type: BI_SHOW_FALLBACK_STATE,
    payload,
});
export const biAttemptLoginSignup = (payload) => ({
    type: BI_ATTEMPT_LOGIN_SIGNUP,
    payload,
});
export const biInitiateFileUpload = (payload) => ({
    type: BI_INITIATE_FILE_UPLOAD,
    payload,
});
export const biInitiateImageUpload = (payload) => ({
    type: BI_INITIATE_IMAGE_UPLOAD,
    payload,
});
export const biInitiateReaction = (payload) => ({ type: BI_INITIATE_REACTION, payload });
export const biClickShowMoreBtn = (payload) => ({
    type: BI_CLICK_SHOW_MORE_BTN,
    payload,
});
export const biClickPublishSelectBtn = (payload) => ({
    type: BI_CLICK_PUBLISH_SELECT_BTN,
    payload,
});
export const biCommentFormExpanded = (payload) => ({
    type: BI_COMMENT_FORM_EXPANDED,
    payload,
});
export const biCaptchaEvent = (payload) => ({
    type: BI_CAPTCHA_EVENT,
    payload,
});
export const biOpenReactionList = (payload) => ({
    type: BI_OPEN_REACTION_LIST,
    payload,
});
export const biClickEmotionListTab = (payload) => ({
    type: BI_CLICK_EMOTION_LIST_TAB,
    payload,
});
export const biShowCommentReplySubmissionWarning = (payload) => ({
    type: BI_SHOW_COMMENT_REPLY_SUBMISSION_WARNING,
    payload,
});
//# sourceMappingURL=bi-actions.js.map